import useTenants from './useTenants';

export default useTenants;
